var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-tooltip', {
    attrs: {
      "top": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "large": ""
          },
          on: {
            "click": _vm.toggle
          }
        }, on), [!_vm.darkMode ? _c('v-icon', [_vm._v("mdi-weather-night")]) : _vm._e(), _vm.darkMode ? _c('v-icon', [_vm._v("mdi-weather-sunny")]) : _vm._e()], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Toggle Dark Mode")])]), _c('v-tooltip', {
    attrs: {
      "top": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "large": ""
          },
          on: {
            "click": _vm.reportBug
          }
        }, on), [_c('v-icon', [_vm._v("mdi-bug")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Einen Fehler melden")])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }